export default __webpack_public_path__ + "static/media/bdd-logo.0dd38301.png";